import Vue from 'vue';
import Vuex from 'vuex';
import { getAdminInfo } from '@/api/admin';

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    token: localStorage.getItem('token') || '',
    userInfo: JSON.parse(localStorage.getItem('userInfo') || '{}')
  },
  mutations: {
    SET_TOKEN(state, token) {
      state.token = token;
      localStorage.setItem('token', token);
    },
    SET_USER_INFO(state, userInfo) {
      state.userInfo = userInfo;
      localStorage.setItem('userInfo', JSON.stringify(userInfo));
    },
    LOGOUT(state) {
      state.token = '';
      state.userInfo = {};
      localStorage.removeItem('token');
      localStorage.removeItem('userInfo');
    }
  },
  actions: {
    async login({ commit }, data) {
      commit('SET_TOKEN', data.token);
      commit('SET_USER_INFO', data.userInfo);
    },
    async logout({ commit }) {
      commit('LOGOUT');
    },
    async fetchUserInfo({ commit }) {
      const res = await getAdminInfo();
      commit('SET_USER_INFO', res.data);
    }
  },
  getters: {
    token: state => state.token,
    userInfo: state => state.userInfo,
    role: state => state.userInfo.role || ''
  }
});
